export const RENTAL = {
  // Header
  appLogo: "app-logo",
  headerAvatar: "header-avatar",
  headerStatsTotal: "header-stat-total",
  headerStatsFavs: "header-stat-favs",
  headerStatsAvg: "header-stat-avg",

  // URL input hero
  urlInput: "url-input",
  parseUrlBtn: "parse-url-btn",
  manualAddBtn: "manual-add-btn",
  pasteTextToggle: "paste-text-toggle",
  pasteTextArea: "paste-text-area",
  pasteSourceUrl: "paste-source-url",
  pasteImageUrl: "paste-image-url",
  parseTextBtn: "parse-text-btn",

  // Manual add dialog
  manualDialog: "manual-add-dialog",
  manualTitle: "manual-title-input",
  manualRent: "manual-rent-input",
  manualBedrooms: "manual-bedrooms-input",
  manualBathrooms: "manual-bathrooms-input",
  manualSqft: "manual-sqft-input",
  manualCity: "manual-city-input",
  manualAddress: "manual-address-input",
  manualSourceUrl: "manual-source-url-input",
  manualImageUrl: "manual-image-url-input",
  manualGarage: "manual-garage-switch",
  manualParking: "manual-parking-switch",
  manualPetFriendly: "manual-pet-friendly-switch",
  manualFurnished: "manual-furnished-switch",
  manualLaundry: "manual-laundry-select",
  manualAvailableDate: "manual-available-date-btn",
  manualContactName: "manual-contact-name-input",
  manualContactPhone: "manual-contact-phone-input",
  manualContactEmail: "manual-contact-email-input",
  manualSubmit: "manual-submit-btn",

  // Filter panel
  filterPanel: "filter-panel",
  filterMinRent: "filter-min-rent",
  filterMaxRent: "filter-max-rent",
  filterMinBeds: "filter-min-beds",
  filterMinBaths: "filter-min-baths",
  filterMinSqft: "filter-min-sqft",
  filterCity: "filter-city",
  filterGarage: "filter-garage",
  filterParking: "filter-parking",
  filterPet: "filter-pet",
  filterFurnished: "filter-furnished",
  filterFavorites: "filter-favorites",
  filterClear: "filter-clear-btn",
  sortSelect: "sort-select",

  // Cards
  rentalGrid: "rental-grid",
  rentalCard: (id) => `rental-card-${id}`,
  rentalFav: (id) => `rental-fav-${id}`,
  rentalDelete: (id) => `rental-delete-${id}`,
  rentalOpen: (id) => `rental-open-${id}`,

  // Detail modal
  detailModal: "rental-detail-modal",
  detailClose: "rental-detail-close",
  detailSourceLink: "rental-detail-source-link",
  detailDelete: "rental-detail-delete",
  detailNotes: "rental-detail-notes-input",
  detailContactName: "rental-detail-contact-name-input",
  detailContactPhone: "rental-detail-contact-phone-input",
  detailContactEmail: "rental-detail-contact-email-input",
  detailSave: "rental-detail-save-btn",

  // Empty
  emptyState: "empty-state",

  // Bookmarklet dialog
  bookmarkletOpenBtn: "bookmarklet-open-btn",
  bookmarkletDialog: "bookmarklet-dialog",
  bookmarkletLink: "bookmarklet-link",
};
